export { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from './perfect-scrollbar.module';
export { PerfectScrollbarDirective, PerfectScrollbarConfigInterface } from './perfect-scrollbar.directive';
